import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n/hooks";
import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { isFrench, toggleLanguage } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const switchLanguage = () => {
    const newPath = toggleLanguage();
    navigate(newPath);
  };

  // Create path prefixes for navigation links based on current language
  const getPathPrefix = () => (isFrench ? "/fr" : "");

  return (
    <header
      className={`w-full z-50 transition-all duration-500 ${
        scrolled
          ? "py-3 backdrop-blur-lg bg-white/80 border-b border-white/20 shadow-md"
          : "py-5 bg-white"
      }`}
    >
      <div className="container mx-auto px-4">
        {/* Desktop Navigation - visible on iPad Pro and larger screens (lg breakpoint is 1024px) */}
        <div className="hidden lg:flex lg:justify-between lg:items-center lg:w-full">
          <DesktopNav
            isFrench={isFrench}
            getPathPrefix={getPathPrefix}
            currentPath={location.pathname}
            switchLanguage={switchLanguage}
          />
        </div>

        {/* Mobile Navigation - visible on smaller tablets and phones */}
        <div className="lg:hidden flex justify-between items-center w-full">
          <MobileNav
            isFrench={isFrench}
            getPathPrefix={getPathPrefix}
            toggleMenu={toggleMenu}
            isMenuOpen={isMenuOpen}
            switchLanguage={switchLanguage}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
